export const GOOGLE_REVIEW_TITLE = "⭐ Avaliação Google";
export const GOOGLE_REVIEW_SHORTCUT = "avaliacao_google";
export const GOOGLE_REVIEW_STORES = Object.freeze({
  1:"Rei dos Estofados",
  2:"Rei dos Colchões",
  3:"Mezzo Ponta Grossa",
  4:"Mezzo Curitiba",
});

// A mesma mensagem é preparada no card de Pós-venda e nas respostas rápidas.
// Não envia nada: o envio continua sendo uma ação explícita do consultor.
export function formatGoogleReviewMessage({ nome, consultor, loja, produto, link }) {
  const fields = { nome, consultor, loja, link };
  if (Object.values(fields).some(value => !String(value || "").trim())) {
    throw new Error("Faltam nome do cliente, consultor, loja ou link de avaliação.");
  }
  const product = String(produto || "").trim();
  return `Oi, ${String(nome).trim()}! Aqui é ${String(consultor).trim()}, da ${String(loja).trim()}. 😊 ` +
    `Espero que esteja aproveitando${product ? ` seu ${product}` : ""}! ` +
    `Se puder, conta pra gente como foi sua experiência? Sua avaliação ajuda muito a nossa loja: ${String(link).trim()}. ` +
    `Muito obrigado(a) por confiar na gente! 💛`;
}